//marburg-preset.ts

import { generateColorPalette, generatePaletteTokens } from '@fsf/util';
import { $dt, definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { AuraBaseDesignTokens } from '@primeng/themes/aura/base';
import { Preset } from '@primeng/themes/types';

// const themegreen = {
//   50: '#f3faf5',
//   100: '#c3e7ce',
//   200: '#94d3a6',
//   300: '#64c07f',
//   400: '#35ac58',
//   500: '#059931',
//   600: '#04822a',
//   700: '#046b22',
//   800: '#03541b',
//   900: '#023d14',
//   950: '#01260c',
// };
// const themebrown = {
//   50: '#f7f7f6',
//   100: '#dbd8d4',
//   200: '#beb9b1',
//   300: '#a19b8f',
//   400: '#857c6c',
//   500: '#685d4a',
//   600: '#584f3f',
//   700: '#494134',
//   800: '#393329',
//   900: '#2a251e',
//   950: '#1a1713',
// };
// const themebeige = {
//   50: '#f4f5f5',
//   100: '#cacfd0',
//   200: '#a1a8ac',
//   300: '#778287',
//   400: '#4e5b62',
//   500: '#24353d',
//   600: '#1f2d34',
//   700: '#19252b',
//   800: '#141d22',
//   900: '#0e1518',
//   950: '#090d0f',
// };

const preset: Preset<AuraBaseDesignTokens> = {
  extend: {
    primitive: {
      themegreen: generateColorPalette('#059931'),
      themebrown: generateColorPalette('#685d4a'),
      themebeige: generateColorPalette('#24353d'),
    },
    semantic: {
      secondary: generatePaletteTokens('themebrown'),
      // {
      //   50: '{themebrown.50}',
      //   100: '{themebrown.100}',
      //   200: '{themebrown.200}',
      //   300: '{themebrown.300}',
      //   400: '{themebrown.400}',
      //   500: '{themebrown.500}',
      //   600: '{themebrown.600}',
      //   700: '{themebrown.700}',
      //   800: '{themebrown.800}',
      //   900: '{themebrown.900}',
      //   950: '{themebrown.950}',
      // },
    },
  },
  primitive: {
    borderRadius: {
      xl: '14px',
    },
  },
  semantic: {
    primary: generatePaletteTokens('themegreen'),
    // {
    //   50: '{themegreen.50}',
    //   100: '{themegreen.100}',
    //   200: '{themegreen.200}',
    //   300: '{themegreen.300}',
    //   400: '{themegreen.400}',
    //   500: '{themegreen.500}',
    //   600: '{themegreen.600}',
    //   700: '{themegreen.700}',
    //   800: '{themegreen.800}',
    //   900: '{themegreen.900}',
    //   950: '{themegreen.950}',
    // },
    colorScheme: {
      light: {
        surface: generatePaletteTokens('stone'),
        // {
        //   50: '{stone.50}',
        //   100: '{stone.100}',
        //   200: '{stone.200}',
        //   300: '{stone.300}',
        //   400: '{stone.400}',
        //   500: '{stone.500}',
        //   600: '{stone.600}',
        //   700: '{stone.700}',
        //   800: '{stone.800}',
        //   900: '{stone.900}',
        //   950: '{stone.950}',
        // },
        text: { color: '{secondary.500}' },
      },
    },
    formField: {
      borderRadius: '{border.radius.xl}',
      paddingY: '0.4rem',
    },
  },
  components: {
    datatable: {
      headerCell: {
        padding: '0.3rem 1rem',
      },
      bodyCell: {
        padding: '0.3rem 1rem',
      },
      columnTitle: {
        fontWeight: '300',
      },
    },
    menubar: {
      root: {
        borderRadius: '0',
      },
      colorScheme: {
        light: {
          root: {
            background: '{secondary.50}',
            borderColor: 'transparent',
          },
        },
      },
    },
    panelmenu: {
      root: { gap: '0' },
      panel: {
        first: {
          borderWidth: '0',
        },
        last: {
          borderWidth: '0',
        },
        borderWidth: '0',
        padding: '0 0.25rem',
      },
      item: {
        padding: '0.5rem 0.75rem',
      },
      colorScheme: {
        light: {
          root: {},
        },
      },
      css: ({ dt }: { dt: typeof $dt }) => `
        .layout-sidebar {
            box-shadow: 0px 2px 15px -3px rgba(0, 0, 0, 0.1);
        }
        .p-panelmenu-header-link {
            display: flex;
            flex-direction: row;
        }
        .p-panelmenu-header-link > chevrondownicon,
        .p-panelmenu-header-link > chevronrighticon {
            order: 99;
            margin-left: auto;
            margin-right: 0;
        }
        `,
    },
    card: {
      title: {
        fontWeight: '700',
      },
      colorScheme: {
        light: {
          root: {
            shadow: '0px 2px 15px -3px rgba(0, 0, 0, 0.1)',
          },
        },
      },
    },
    chip: {
      root: {
        paddingY: '0.3rem',
      },
      colorScheme: {
        light: {
          root: {
            background: '{secondary.50}',
          },
        },
      },
    },
    autocomplete: {
      chip: { borderRadius: '16px' },
    },
    breadcrumb: {
      root: {
        padding: '1rem 0',
        background: 'transparent',
      },
    },
  },
};

const CHART_ACCENT_COLORS = ['#B2A982', '#E73F0C'];

let _palette: string[] | null = null;

export const colors = {
  get palette(): string[] {
    if (!_palette) {
      const style = getComputedStyle(document.documentElement);
      const resolve = (token: string) => style.getPropertyValue(token).trim();
      _palette = [
        resolve('--p-primary-500'),
        resolve('--p-secondary-500'),
        resolve('--p-primary-200'),
        resolve('--p-primary-800'),
        resolve('--p-secondary-200'),
        resolve('--p-secondary-800'),
        ...CHART_ACCENT_COLORS,
      ];
    }
    return _palette;
  },
};

export const links = {
  logoSrc:
    'https://kletterwald-marburg.de/files/bilder/Logo%20Kletterwald%20Marburg_RZ.png',
  logoAlt: 'Kletterwald Marburg Logo',
  impressum: 'https://kletterwald-marburg.de/impressum.html',
};

export const ThemePreset = definePreset(Aura, preset);
